import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import "@arco-design/web-react/dist/css/arco.css";
import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom'
import { routeList, HOME_PAGE, LOGIN, ROYALTY_RECEIVING_ACCOUNT_BAND_WX } from './route'
import { refresToken } from './api/Manager';

const App = lazy(() => import('./pages/App'));
const NotFound = lazy(() => import('./pages/Notfound'));
const Login = lazy(() => import('./pages/Login'));
const ROYALTY_BAND_WX = lazy(() => import('./pages/royaltyReceivingAccount/bandWx'));

setInterval(function () {
    refresToken()
}, 20 * 60 * 1000)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Router>
        <Routes>
            <Route path="/" element={<App />} >
                <Route index element={<Navigate to={HOME_PAGE} />} />
                {
                    routeList.map((item) => (
                        item.children.map((i) => (
                            <Route key={i.key} path={i.path} element={
                                <React.Suspense  >
                                    <i.component />
                                </React.Suspense>
                            } />
                        ))
                    ))
                }
            </Route>
            <Route path={LOGIN} element={<Login />} />
            <Route path={ROYALTY_RECEIVING_ACCOUNT_BAND_WX} element={<ROYALTY_BAND_WX />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
    </ Router>
);
